import React, { useMemo } from 'react';

interface SpacerProps {
    direction?: 'horizontal' | 'vertical';
    size?: number;
    align?: 'center' | 'start' | 'end' | 'baseline' | 'stretch';
    justifyContent?: 'space-between' | 'end' | 'center';
    padding?: string;
    children: React.ReactNode;
    id?: string;
    fullHeight?: boolean;
    fullWidth?: boolean;
    className?: string;
}

const Spacer: React.FC<SpacerProps> = ({
    direction = 'horizontal',
    size = 8,
    children,
    align,
    justifyContent,
    padding,
    id,
    fullHeight = false,
    fullWidth = false,
    className = '',
}) => {
    const flexDirection = direction === 'vertical' ? 'column' : 'row';

    const alignItems = useMemo(() => {
        switch (align) {
            case 'center':
                return 'center';
            case 'start':
                return 'flex-start';
            case 'end':
                return 'flex-end';
            case 'baseline':
                return 'baseline';
            case 'stretch':
                return 'stretch';
            default:
                return 'center';
        }
    }, [align]);

    const justifyContentStyle = useMemo(() => {
        switch (justifyContent) {
            case 'space-between':
                return 'space-between';
            case 'center':
                return 'center';
            case 'end':
                return 'flex-end';
            default:
                return 'flex-start';
        }
    }, [justifyContent]);

    const childrenArray = React.Children.toArray(children);

    return (
        <div
            id={id}
            className={`flex ${className}`.trim()}
            style={{
                flexDirection,
                alignItems,
                justifyContent: justifyContentStyle,
                gap: `${size}px`,
                padding,
                height: fullHeight ? '100%' : undefined,
                width: fullWidth ? '100%' : undefined,
            }}
        >
            {childrenArray.map((child, index) => (
                <React.Fragment key={index}>{child}</React.Fragment>
            ))}
        </div>
    );
};

export default Spacer;
